export default __webpack_public_path__ + "static/heroSectionBgMob-cdc707e356600cff11b548745254fa13.png";